import { formatInr } from "./currency";

export type BalanceDisplayInfo = {
  closingBalance?: number;
  ClosingBalance?: number;
  balance?: number;
  Balance?: number;
  balanceType?: string;
  BalanceType?: string;
  type?: string;
  Type?: string;
  DebitTotal?: number;
  debitTotal?: number;
  CreditTotal?: number;
  creditTotal?: number;
  facilityType?: string;
  FacilityType?: string;
  availableOverdraftLimit?: number;
  AvailableOverdraftLimit?: number;
};

export function getSignedBalance(source?: BalanceDisplayInfo | null) {
  if (!source) return 0;
  return Number(
    source.closingBalance ??
    source.ClosingBalance ??
    source.balance ??
    source.Balance ??
    (Number(source.DebitTotal ?? source.debitTotal ?? 0) - Number(source.CreditTotal ?? source.creditTotal ?? 0))
  );
}

export function getDisplayBalanceType(source?: BalanceDisplayInfo | null) {
  const value = getSignedBalance(source);
  return String(source?.balanceType ?? source?.BalanceType ?? source?.type ?? source?.Type ?? (value < 0 ? "Cr" : "Dr"));
}

export function isOverdraftFacility(source?: BalanceDisplayInfo | null) {
  const facilityType = String(source?.facilityType ?? source?.FacilityType ?? "Normal");
  return Boolean(facilityType && facilityType !== "Normal");
}

export function balanceText(balance?: BalanceDisplayInfo | null) {
  if (!balance) return formatInr(0);
  const value = getSignedBalance(balance);
  const type = getDisplayBalanceType(balance);
  const available = balance.availableOverdraftLimit ?? balance.AvailableOverdraftLimit;
  const odText = isOverdraftFacility(balance) && available !== undefined
    ? ` | Available OD: ${formatInr(Number(available))}`
    : "";
  return `${formatInr(Math.abs(value))}${type ? ` ${type}` : ""}${odText}`;
}
